module.exports = __webpack_public_path__ + "img/CS-UL-II-Profiles.93c6c1d3.jpg";